import type { components } from "./schema";

type HealthResponse = components["schemas"]["HealthResponse"];

/** Liveness probe; no auth and no session refresh. */
export async function fetchGitSha(): Promise<string | null> {
  const res = await fetch("/api/health");
  if (!res.ok) {
    return null;
  }
  const body = (await res.json()) as HealthResponse;
  return body.git_sha ?? null;
}
